import React, { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  Routes,
  useMatch,
  useParams,
  useRoutes,
} from "react-router-dom";
import Home from "./components/Home/Home";
import Main from "./components/Main";
import EventTypes from "./components/CreateEvent/EventTypes";
import Banner from "./components/Banner";
import CreateNew from "./components/CreateEvent/CreateNew";
import Events from "./components/Home/Event";
import { useQuery, gql } from "@apollo/client";
import { CircularProgress, Typography } from "@mui/material";
import EventPage from "./components/Pages/EventPage";
import { events } from "./util/events";
import AvailabilityHeader from "./components/Availability/AvailabilityHeader";
import AvailabilityPage from "./components/Availability/AvailiabiltyPage";
import BookPage from "./components/Pages/BookPage";
import ConfirmPage from "./components/Pages/ConfirmPage";
import { useLocation } from "react-router-dom";
import LoginPage from "./components/Pages/LoginPage";
import Login from "./components/Auth/Login/Login";
import jwtDecode from "jwt-decode";
import SignUp from "./components/Auth/Signup";
import UserPage from "./components/Pages/UserPage";
import UpdateHeader from "./components/UpdateHeader";
import UserEventPage from "./components/Pages/UserEventsPage";
import Icon from "./assets/images/Icon.png";
import MainPage from "./components/Pages/MainPage";
import MainPageBanner from "./components/MainPageBanner";
import Error from "./components/Error";
import EventChoice from "./components/CreateEvent/EventChoice";
import { ALL_EVENTS, GET_EVENTS, getUsers } from "./graphql/querys";
import IntegrationHeader from "./components/Integrations/IntegrationHeader";
import IntegrationPage from "./components/Integrations/IntegrationPage";
import Integration from "./components/Integrations/Integration";
import PricingPage from "./components/Pages/PricingPage";
import PaymentPage from "./components/Pages/PaymentPage";
import ForgotPassword from "./components/Auth/ForgotPassword";
import SubscriptionSuccessPage from "./components/Pages/SubscriptionSuccessPage";
import AnalyticsPage from "./components/Pages/AnalyticsPage";
import EventsRatingPage from "./components/Pages/EventsRatingPage";
import { images } from "./util/images";
import { ethDateTime } from "./util/Ethiopia/Ethiopia";

function App() {
  const [token, setToken] = useState(
    localStorage.getItem("token") &&
      localStorage.getItem("token") !== "undefined"
      ? localStorage.getItem("token")
      : null
  );
  const [userDetails, setUserDetails] = useState({});
  const [finalEvents, setFinalEvents] = useState(events.slice());
  const allEvents = [];
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");
  // Decode the token and extract the full name
  const decodedToken = token && token !== "undefined" ? jwtDecode(token) : null;
  const { loading, error, data, refetch } = useQuery(GET_EVENTS, {
    variables: { companyId: decodedToken ? decodedToken.userId : 0 },
  });
  const {
    loading: allLoading,
    error: allError,
    data: allData,
    refetch: allRefetch,
  } = useQuery(ALL_EVENTS, {
    variables: { companyId: decodedToken ? decodedToken.userId : 0 },
  });
  const routes = [
    { path: "/", element: <Home /> },
    { path: "/about", element: "" },
    { path: "/settings", element: "" },
    { path: "*", element: <NotFound /> },
  ];

  const [userFromUrl, setUserFromUrl] = useState("");

  useEffect(() => {
    // Extract the user from the URL path
    const urlParts = window.location.pathname.split("/");
    if (urlParts.length > 1) {
      const user = urlParts[1];
      setUserFromUrl(user);
    }
  }, []);

  const { user } = useParams();
  const {
    loading: usersLoading,
    error: usersError,
    data: usersData,
    refetch: usersRefetch,
  } = useQuery(getUsers, {
    variables: { url: userFromUrl || "" },
  });
  const login = (access_token) => {
    setToken(access_token);
  };
  const [spilledDates, setSpilledDates] = useState([]);
  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };
  useEffect(() => {
    if (!loading) {
      var e = [];
      for (let i = 0; i < data?.getCompanyEvents.length; i++) {
        const {
          id,
          companyId: userId,
          location,
          title: name,
          desc,
          color,
          link,
          length,
          start,
          end,
          locationType,
          groupId,
          maxInvitees,
          showRemaining,
          eventType,
          increments,
          eventsPerDay,
          hidden,
          phoneNumber,
          phoneNumberRadio,
          bookingOption,
          image,bookingApproval,
          specialBookingOption
        } = data?.getCompanyEvents[i];
        e.push({
          id,
          userId,
          location,
          name,
          desc,
          color,
          link,
          length,
          start: start,
          end: end,
          locationType,
          groupId: parseInt(groupId),
          maxInvitees,
          showRemaining,
          eventType,
          bookingOption,
          increments,
          eventsPerDay,
          hidden,
          phoneNumber,
          phoneNumberRadio,
          image,bookingApproval,
          specialBookingOption
        });
      }
      setFinalEvents(e);
    }
  }, [loading, data]);
  const [backgroundImage, setImage] = useState("");
  if (loading || allLoading || usersLoading) {
    return (
      <div className="circular-progress">
        <CircularProgress disableShrink size={100} />
      </div>
    );
  }
  if (error || allError || usersError) {
    console.log(error || allError || usersError);
    return <Error />;
  }
  const ProtectedComponent = ({ children, token }) => {
    const location = useLocation();

    if (!token) {
      // redirect to login page
      return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
  };
  for (let i = 0; i < allData?.getEvents.length; i++) {
    const {
      id,
      companyId: userId,
      location,
      title: name,
      desc,
      color,
      link,
      length,
      start,
      end,
      locationType,
      groupId,
      maxInvitees,
      showRemaining,
      eventType,
      increments,
      eventsPerDay,
      hidden,
      phoneNumber,
      bookingOption,
      phoneNumberRadio,
      image,bookingApproval,
      specialBookingOption
    } = allData?.getEvents[i];

    allEvents.push({
      id,
      userId,
      location,
      name,
      desc,
      color,
      link,
      bookingOption,
      length,
      start,
      end,
      locationType,
      groupId: parseInt(groupId),
      maxInvitees,
      showRemaining,
      eventType,
      increments,
      eventsPerDay,
      hidden,
      phoneNumber,
      phoneNumberRadio,
      image: image ? image : 0,bookingApproval,
      specialBookingOption
    });
  }
  var pagesWithBackground = ["/login", "/signup", "/forgotpassword"];
  return (
    <div
      className="mainContainer"
      style={
        pagesWithBackground.includes(window.location.pathname)
          ? {
              backgroundImage:
                "url(https://images.pexels.com/photos/4913802/pexels-photo-4913802.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1)",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {
              backgroundImage: backgroundImage
                ? "url(" +
                    images?.find((val) => val.id == backgroundImage)?.image ||
                  "" + ")"
                : "",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }
      }
    >
      <main>
        {window.location.pathname.includes("subscription-success") ? (
          ""
        ) : window.location.pathname == "/" ||
          window.location.pathname == "/pricing" ? (
          <MainPageBanner data={decodedToken} token={token} logout={logout} />
        ) : isAppRoute ? (
          <Banner data={decodedToken} token={token} logout={logout} />
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "30px 0",
            }}
          >
            <img
              onClick={() => {
                decodedToken
                  ? (window.location.href = "/app/events")
                  : (window.location.href = "/");
              }}
              src={Icon}
              style={{ margin: 0, width: "200px", cursor: "pointer" }}
            />
            {!token ? () => <Navigate to="/login" /> : ""}
          </div>
        )}
        <div
          style={{
            paddingTop:
              isAppRoute && location.pathname !== "*" ? "87px" : "0px",
          }}
        >
          <Routes>
            <Route path="*" element={<NotFound />} />{" "}
            <Route
              path="/"
              element={
                <MainPage decodedToken={decodedToken ? decodedToken : ""} />
              }
            />
            <Route
              path="/billing/:plan"
              element={
                <ProtectedComponent token={token}>
                  <PaymentPage
                    decodedToken={decodedToken ? decodedToken : ""}
                  />
                </ProtectedComponent>
              }
            />
            <Route
              path="/subscription-success/:plan"
              element={
                <ProtectedComponent token={token}>
                  <SubscriptionSuccessPage
                    decodedToken={decodedToken ? decodedToken : ""}
                  />
                </ProtectedComponent>
              }
            />
            <Route
              path="/pricing"
              element={
                <PricingPage decodedToken={decodedToken ? decodedToken : ""} />
              }
            />
            <Route
              path="/app/integrations"
              element={
                <ProtectedComponent token={token}>
                  <Main
                    content={IntegrationHeader}
                    display={IntegrationPage}
                    data={finalEvents}
                    refetch={refetch}
                    currentUser={decodedToken ? decodedToken : ""}
                  />
                </ProtectedComponent>
              }
            />{" "}
            <Route
              path="/app/analytics"
              element={
                decodedToken?.role?.toLowerCase() == "starter" ? (
                  <Navigate to="/app/events" />
                ) : (
                  <ProtectedComponent token={token}>
                    <AnalyticsPage
                      content={IntegrationHeader}
                      display={IntegrationPage}
                      data={finalEvents}
                      refetch={refetch}
                      currentUser={decodedToken ? decodedToken : ""}
                    />
                  </ProtectedComponent>
                )
              }
            />
            <Route
              path="/app/integrations/:integration"
              element={
                token ? (
                  <Main
                    content={IntegrationHeader}
                    display={Integration}
                    data={finalEvents}
                    refetch={refetch}
                    currentUser={decodedToken ? decodedToken : ""}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/login"
              element={
                !token ? (
                  <Login token={token} login={login} />
                ) : (
                  <Navigate to="/app/events" />
                )
              }
            />
            <Route
              path="/forgotpassword"
              element={
                !token ? (
                  <ForgotPassword token={token} login={login} />
                ) : (
                  <Navigate to="/app/events" />
                )
              }
            />
            <Route
              path="/signup"
              element={
                !token ? (
                  <SignUp token={token} login={login} />
                ) : (
                  <Navigate to="/app/events" />
                )
              }
            />
            <Route
              path="/app/events"
              element={
                token ? (
                  <Main
                    content={Home}
                    display={Events}
                    data={finalEvents}
                    refetch={refetch}
                    currentUser={decodedToken ? decodedToken : ""}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />{" "}
            <Route
              path="/app/profile"
              element={
                token ? (
                  <Main
                    content={UpdateHeader}
                    display={UserPage}
                    logout={logout}
                    data={decodedToken}
                    setToken={setToken}
                  />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/app/availability"
              element={
                <ProtectedComponent token={token}>
                  <Main
                    content={AvailabilityHeader}
                    display={AvailabilityPage}
                    currentUser={decodedToken ? decodedToken : ""}
                    data={finalEvents}
                    refetch={refetch}
                  />
                </ProtectedComponent>
              }
            />
            <Route
              path="/app/new"
              element={
                finalEvents.length &&
                decodedToken?.role?.toLowerCase() == "starter" ? (
                  <Navigate to="/app/events" />
                ) : (
                  <ProtectedComponent token={token}>
                    <Main
                      content={CreateNew}
                      display={EventChoice}
                      data={finalEvents}
                      currentUser={decodedToken ? decodedToken : ""}
                    />
                  </ProtectedComponent>
                )
              }
            />{" "}
            <Route
              path="/app/create/group"
              element={
                decodedToken?.role?.toLowerCase() == "starter" ? (
                  <Navigate to="/app/new" />
                ) : (
                  <ProtectedComponent token={token}>
                    <Main
                      content={CreateNew}
                      display={EventTypes}
                      data={finalEvents}
                      group={true}
                      currentUser={decodedToken ? decodedToken : ""}
                    />
                  </ProtectedComponent>
                )
              }
            />
            <Route
              path="/app/create/one"
              element={
                finalEvents.length &&
                decodedToken?.role?.toLowerCase() == "starter" ? (
                  <Navigate to="/app/events" />
                ) : (
                  <ProtectedComponent token={token}>
                    <Main
                      content={CreateNew}
                      display={EventTypes}
                      data={finalEvents}
                      currentUser={decodedToken ? decodedToken : ""}
                    />
                  </ProtectedComponent>
                )
              }
            />{" "}
            <Route
              path="/app/update/:id"
              element={
                <ProtectedComponent token={token}>
                  <Main
                    content={CreateNew}
                    display={EventTypes}
                    data={finalEvents}
                    currentUser={decodedToken ? decodedToken : ""}
                    update={finalEvents}
                    refetch={refetch}
                  />
                </ProtectedComponent>
              }
            />
            <Route
              path="/:user"
              element={
                <UserEventPage
                  url={decodedToken ? decodedToken?.url : ""}
                  data={finalEvents}
                  currentUser={decodedToken ? decodedToken : ""}
                />
              }
            />
            <Route
              path="/:user/events/:id"
              element={
                <EventPage
                  setImage={setImage}
                  allEvents={allEvents}
                  usersData={usersData.users[0]}
                  data={finalEvents}
                  spilledDates={spilledDates}
                  setSpilledDates={setSpilledDates}
                  currentUser={decodedToken ? decodedToken : ""}
                />
              }
            />{" "}
            <Route
              path="/:user/events/:id/ratings"
              element={
                <EventsRatingPage
                  data={finalEvents}
                  currentUser={decodedToken ? decodedToken : ""}
                />
              }
            />
            <Route
              path="/:user/events/:id/:time"
              element={
                <EventPage
                  url={decodedToken ? decodedToken.url : ""}
                  data={finalEvents}
                  all={allEvents}
                  spilledDates={spilledDates}
                  setSpilledDates={setSpilledDates}
                  currentUser={decodedToken ? decodedToken : ""}
                  setImage={setImage}
                  allEvents={allEvents}
                  usersData={usersData.users[0]}
                  BookPage={BookPage}
                />
              }
            />
            <Route
              path="/:user/events/invitees/:bookingId/confirmed"
              element={
                <ConfirmPage
                  data={finalEvents}
                  all={allEvents}
                  currentUser={decodedToken ? decodedToken : ""}
                />
              }
            />
          </Routes>
        </div>
      </main>
    </div>
  );
}

const NotFound = () => {
  return <Error />;
};

export default App;
